import React from 'react';
import PropTypes from 'prop-types';
import { combineClassNames, useTheme } from 'core/css';
import { SvgIcon } from 'core/icons';

const ButtonText = ({ className, ...restProps }) => (
  <div
    className={combineClassNames('button__text', className)}
    {...restProps}
  />
);

const ButtonIcon = ({ className, ...restProps }) => (
  <SvgIcon
    className={combineClassNames('button__icon', className)}
    {...restProps}
  />
);

const Button = ({
  as: Type = 'button',
  primary,
  secondary,
  invert,
  link,
  className,
  ...restProps
}) => (
  <Type
    type={Type === 'button' ? 'button' : null}
    className={combineClassNames(
      'button',
      primary ? (invert ? 'button--primary--invert' : 'button--primary') : '',
      secondary
        ? invert
          ? 'button--secondary--invert'
          : 'button--secondary'
        : '',
      className
    )}
    {...restProps}
  />
);

Button.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  link: PropTypes.bool,
  className: PropTypes.string,
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.elementType,
  ]),
};

// Allows us to specify certain classes by brand.
const ThemedButton = (props) => {
  const { theme, className, ...restProps } = props;
  const themeClass = useTheme(theme);
  return (
    <Button
      {...restProps}
      className={combineClassNames(themeClass, className)}
    />
  );
};

const PrimaryButton = (props) => <Button {...props} primary />;

const SecondaryButton = (props) => <Button {...props} secondary />;

const LinkButton = (props) => {
  const { as = 'a', ...restProps } = props;
  return <Button as={as} {...restProps} link />;
};

export {
  Button,
  ButtonText,
  ButtonIcon,
  ThemedButton,
  PrimaryButton,
  SecondaryButton,
  LinkButton,
};
